export default __webpack_public_path__ + "static/media/features-bg.69c5091d.png";